<template>
  <v-container fluid>
    <v-row v-if="!loading">
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="5" lg="3">
            <material-card v-if="passwordChanged">
              <p class="headline primary--text">Senha Alterada com Sucesso</p>
              <p class="body primary--text font-weight-black">
                Olá {{ user.nome }}
              </p>
              <p class="body primary--text font-weight-black">Sua senha foi redefinida para o seu CPF.</p>
              <p v-if="user.tipo === 2" class="headline primary--text">Acesse o aplicativo e altere sua senha caso achar necessário.</p>
              <v-btn v-else block to="/login" color="primary">Acessar sistema</v-btn>
            </material-card>
            <material-card v-else>
              <p class="headline primary--text">Não foi possível redefinir a senha. Faça uma nova requisição.</p>
            </material-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import rules from "../../utils/rules";

export default {
  components: {},
  mixins: [rules],
  data() {
    return {
      user: {},
      loading: true,
      token: null,      
      passwordChanged: false,      
    };
  },
  mounted() {
    this.token = this.$route.params.token;
    if (this.token) {
      this.resetarSenha(this.token)
        .then((data) => {
          this.passwordChanged = true;
          this.user = data;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });        
    }
  },
  methods: {
    ...mapActions("auth", ["resetarSenha"])    
  },
};
</script>
